import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface TrustScoreProps {
  score: number;
  size?: 'sm' | 'md' | 'lg';
}
export function TrustScore({
  score,
  size = 'md'
}: TrustScoreProps) {
  const getColor = (score: number) => {
    if (score >= 9) return 'text-green-600 bg-green-50 border-green-200';
    if (score >= 8) return 'text-blue-600 bg-blue-50 border-blue-200';
    if (score >= 7) return 'text-yellow-600 bg-yellow-50 border-yellow-200';
    return 'text-orange-600 bg-orange-50 border-orange-200';
  };
  const sizeStyles = {
    sm: 'text-sm px-2 py-1',
    md: 'text-base px-3 py-1.5',
    lg: 'text-lg px-4 py-2'
  };
  const iconSize = {
    sm: 14,
    md: 16,
    lg: 20
  };
  return <div className={`inline-flex items-center gap-1.5 font-semibold rounded-lg border ${getColor(score)} ${sizeStyles[size]}`} data-id="element-239">
      <ShieldCheckIcon size={iconSize[size]} data-id="element-240" />
      <span data-id="element-241">{score.toFixed(1)}</span>
    </div>;
}